class MAReviewsMarquee extends HTMLElement {
  connectedCallback() {
    // Double rAF ensures layout is computed and scrollWidth is non-zero.
    requestAnimationFrame(() => requestAnimationFrame(() => {
      this.querySelectorAll('.ma-rm__row').forEach(row => {
        const goRight = row.dataset.direction === 'right';
        const speed   = parseFloat(row.dataset.speed) || 0.45;
        let paused    = false;

        const getHalf = () => row.scrollWidth / 2;

        // Track position in JS — never read back row.scrollLeft during animation.
        // iOS Safari floors sub-pixel scroll values, breaking the += accumulation.
        let pos = goRight ? getHalf() : 0;
        row.scrollLeft = pos;

        const tick = () => {
          if (!paused) {
            const half = getHalf();
            if (goRight) {
              pos -= speed;
              if (pos <= 0) pos += half;
            } else {
              pos += speed;
              if (pos >= half) pos -= half;
            }
            row.scrollLeft = pos;
          }
          requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);

        // Delay re-sync by one rAF so the browser has committed the final scroll
        // position before we read it. Reading scrollLeft synchronously in touchend
        // can return a stale (pre-swipe) value on iOS Safari.
        const resume = () => {
          requestAnimationFrame(() => {
            pos = row.scrollLeft;
            paused = false;
          });
        };

        // Touch events handle mobile. Kept separate from pointer events to avoid
        // pointercancel firing mid-swipe on iOS (browser fires it when taking over
        // a scroll gesture, at which point scrollLeft is still the pre-swipe value).
        row.addEventListener('touchstart', () => { paused = true; }, { passive: true });
        row.addEventListener('touchend',   resume,                   { passive: true });

        // Pointer events handle desktop mouse. Excluded from touch (pointerType check)
        // so they don't double-fire alongside touch events on mobile.
        row.addEventListener('pointerdown',   (e) => { if (e.pointerType !== 'touch') paused = true; });
        row.addEventListener('pointerup',     (e) => { if (e.pointerType !== 'touch') resume(); });
        row.addEventListener('pointercancel', (e) => { if (e.pointerType !== 'touch') resume(); });
      });
    }));
  }
}

customElements.define('ma-reviews-marquee', MAReviewsMarquee);
